import { HDate, HebrewCalendar, months } from '@hebcal/core';

/**
 * Extra day labels that never change times (spec section 10): Taanit Bechorot,
 * Shushan Purim, the special Shabbosim, Isru Chag and so on. Shown next to the
 * main labels (getDayLabels in minyanDay.ts).
 */
const SHOWN: Record<string, { he?: string }> = {
  "Ta'anit Bechorot": {},
  'Erev Purim': {},
  'Shushan Purim': {},
  'Purim Katan': {},
  'Tu BiShvat': {},
  'Lag BaOmer': {},
  'Pesach Sheni': {},
  "Tu B'Av": {},
  'Yom HaShoah': {},
  'Yom HaZikaron': {},
  "Yom HaAtzma'ut": {},
  'Yom Yerushalayim': {},
  'Leil Selichot': { he: 'ליל סליחות' },
  'Shabbat Shuva': {},
  'Shabbat Shirah': {},
  'Shabbat Shekalim': {},
  'Shabbat Zachor': {},
  'Shabbat Parah': {},
  'Shabbat HaChodesh': {},
  'Shabbat HaGadol': {},
  'Shabbat Chazon': {},
  'Shabbat Nachamu': {},
};

function hdateOf(dateStr: string): HDate {
  return new HDate(new Date(`${dateStr}T12:00:00Z`));
}

/** Isru Chag in Israel: the day after Simchat Torah, Pesach and Shavuot. */
function isIsruChag(hd: HDate): boolean {
  const m = hd.getMonth();
  const d = hd.getDate();
  return (m === months.TISHREI && d === 23) || (m === months.NISAN && d === 22) || (m === months.SIVAN && d === 7);
}

export function getCalendarTags(dateStr: string, lang: 'en' | 'he'): string[] {
  const hd = hdateOf(dateStr);
  const tags: string[] = [];
  for (const ev of HebrewCalendar.getHolidaysOnDate(hd, true) ?? []) {
    const shown = SHOWN[ev.getDesc()];
    if (!shown) continue;
    tags.push(lang === 'he' ? shown.he ?? ev.render('he-x-NoNikud') : ev.render('en'));
  }
  if (isIsruChag(hd)) tags.push(lang === 'he' ? 'אסרו חג' : 'Isru Chag');
  return tags;
}
